import React, { Component } from 'react';
import './App.css';
import portrait from './images/nickkraly_portrait_2018.png'


class Content extends Component {
	
    handleNavClick(page){
		this.props.trayCB(page)
    }

  render() {

    return (
    	<div className="trayContents">
    	
      	 <div className="traySection content1">
      	 <p className="heavy white">Design thinking</p>
      	 <p>User Experience Design</p>
      	 <p>Product Management & Innovation</p>
      	 <p>Brand & Identity</p>
      	 </div>
      	 <div className="traySection white">
	      <p className="heavy dkgray">Creative Process </p>
	      <p className="bold bottomspacer">Ideate > Socialize > Realize </p>
	      <p>Design and UX work have become process heavy over the last 10 years or so. Oddmachine works with as 
	      little process as possible to generate and maintain maximum creativity. </p>
      	</div>
		</div>
    )
  }
}

export default Content;


// WEBPACK FOOTER //
// ./src/Content.js